import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getClientsUrl             = '/api/admin/dashboard/getClients';
const postClientUrl             = '/api/admin/dashboard/postClient';
const postClientListUrl         = '/api/admin/dashboard/postClientList';
const getClientDetailsUrl       = '/api/admin/dashboard/getClientDetails';
const addCommentUrl             = '/api/admin/dashboard/addComment';
const deleteCommentUrl          = '/api/admin/dashboard/deleteComment';
const sendLinkUrl               = '/api/admin/dashboard/sendLink';
const getMedicalFormUrl         = '/api/admin/dashboard/getMedicalForm';
const getMedicalFormJuvenileUrl = '/api/admin/dashboard/getMedicalFormJuvenile';
const postMedicalFormUrl        = '/api/admin/dashboard/postMedicalForm';
const postMedicalFormJuvenileUrl = '/api/admin/dashboard/postMedicalFormJuvenile';
const verifyMedicalFormUrl      = '/api/admin/dashboard/verifyMedicalForm';
const getMISUrl                 = '/api/admin/dashboard/getMIS';


export const getClientList = async (filters = {}) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const params = {};

    if (filters.search) params.search = filters.search;
    if (filters.type && filters.type !== 'All') params.testType = filters.type;
    if (filters.tpa !== undefined && filters.tpa !== null && filters.tpa !== 0) params.tpa = filters.tpa;
    if (filters.status && filters.status !== 'All') params.status = filters.status;

    const response = await axiosGet(
        getClientsUrl,
        { headers: { auth_token: `bearer ${token}` }, params }
    );
    return response;
}

export const postClient = async (client) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postClientUrl,
        { client },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postClientList = async (clients) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postClientListUrl,
        { clients },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const getClientDetails = async (clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        getClientDetailsUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { clientId }} 
    );
    return response;
};

export const addComment = async (comment) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        addCommentUrl,
        { comment },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const deleteComment = async (id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        deleteCommentUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { id }} 
    );
    return response;
};

export const sendLink = async(clientId, mobile) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        sendLinkUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { clientId, mobile }} 
    );
    return response;
}

export const getMedicalForm = async(clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        getMedicalFormUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { clientId }} 
    );
    return response;
}

export const getMedicalFormJuvenile = async(clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        getMedicalFormJuvenileUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { clientId }} 
    );
    return response;
}

export const postMedicalForm = async (form, media) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postMedicalFormUrl,
        { form, media },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postMedicalFormJuvenile = async (form, media) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postMedicalFormJuvenileUrl,
        { form, media },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const verifyMedicalForm = async(clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        verifyMedicalFormUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { clientId }} 
    );
    return response;
}

export const getMIS = async(from, to) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getMISUrl, { headers: { auth_token: `bearer ${token}` }, params: { from, to }} );
    return response;
}
